import React from 'react';
import KpiDevToDonePanel from './KpiDevToDonePanel';
import azureDevOpsService from './services/azureDevOpsService';

export default function KpiPBIDevToDoneTime() {
  return (
    <KpiDevToDonePanel
      title="Temps moyen Dev → Done (PBI)"
      subtitle="Product Backlog Items · Tribu Argonos · de l'état 2-Dev à 6-Done"
      fetchFn={(start, end, sample) =>
        azureDevOpsService.getAveragePBIDevToDoneTime(start, end, sample)
      }
    />
  );
}
